<template>
<div class="sidebar map-sidebar">
	<h4 class="sidebar-title">Explore Investment Opportunities</h4>
	<hr>
	<grid flat class="tabs-caption">
		<grid-item size="1/2">
			<h3 class="pos-left" :class="activeTab == 0 ? 'active' : ''" @click="activeTab = 0">Opportunities</h3>
		</grid-item>
		<grid-item size="1/2">
			<h3 class="pos-right" :class="activeTab == 1 ? 'active' : ''" @click="activeTab = 1">Companies</h3>
		</grid-item>
	</grid>
	<grid flat class="tabs-content" v-if="activeTab == 0">
		<grid-item size="1/1">
			<custom-multiple-select
				label="Search by Sector"
				:itemList="formattedSectors"
				itemValue="id"
				v-model="selectedSectors"
			/>
			<custom-multiple-select
				label="Search by Region"
				:itemList="formattedRegions"
				itemValue="id"
				v-model="selectedRegions"
			/>
			<custom-input
				type="text"
				placeholder="Keyword Search"
				inputStyle="dark"
				v-model="keyWordValue"
			/>
			<sidebar-additional-criteria label="Additional Search Criteria" :itemList="additionalCriteriaList"/>
			<hr>
			<button class="button primary isDisabled"
				ref="opportunitySearchButton"
				@click="search()"
				v-text="'View on map'"
			/>
		</grid-item>
	</grid>
	<grid class="tabs-content" v-if="activeTab == 1">
		<grid-item size="1/1">
			<custom-multiple-select
				label="Search by Sector"
				:itemList="formattedSectors"
				itemValue="id"
				v-model="selectedSectors"
			/>
			<custom-multiple-select
				label="Search by Region"
				:itemList="formattedRegions"
				itemValue="id"
				v-model="selectedRegions"
			/>
			<custom-input
				type="text"
				placeholder="Keyword Search"
				inputStyle="dark"
				v-model="keyWordValue"
			/>
			<sidebar-additional-criteria label="Additional Search Criteria" :itemList="additionalCriteriaList"/>
			<hr>
			<button class="button primary isDisabled" @click="search()">View on map</button>
		</grid-item>
	</grid>
</div>
</template>

<script>
import CustomMultipleSelect from '@/components/secondary/CustomMultipleSelect'
import CustomInput from '@/components/secondary/CustomInput'
import SidebarAdditionalCriteria from '@/components/secondary/SidebarAdditionalCriteria'
import { mapActions, mapState } from 'vuex'

export default {
	components: {
		CustomMultipleSelect,
		CustomInput,
		SidebarAdditionalCriteria
	},
	data: () => ({
		activeTab: 0,
		selectedSectors: [],
		selectedRegions: [],
		keyWordValue: null,
		additionalCriteriaList: [
			{name: 'Pre-feasibility study', status: false},
			{name: 'Free zone / special economic zone', status: false},
			{name: 'Opportunity with land', status: false},
			{name: 'Land only', status: false},
			{name: 'ppp', status: false}
		]
	}),
	computed: {
		...mapState({
			sectors: ({ SectorStore }) => SectorStore.list,
			regions: ({ RegionStore }) => RegionStore.list
		}),
		formattedSectors() {
			let total = 0
			let items = this.sectors.map(item => {
				total += item.count
				return {
					...item,
					name: item.name + ' (' + item.count + ')',
					disabled: (item.count < 1)
				}
			})
			items.unshift({
				id: 0,
				name: 'All (' + total + ')',
				disabled: false
			})
			return items
		},
		formattedRegions() {
			let total = 0
			let items = this.regions.map(item => {
				total += item.count
				return {
					...item,
					name: item.name + ' (' + item.count + ')',
					disabled: (item.count < 1)
				}
			})
			items.unshift({
				id: 0,
				name: 'All (' + total + ')',
				disabled: false
			})
			return items
		}
	},
	mounted() {
		this.getSectors()
		this.$root.$emit('removeAllMarkers')
		
		let query = this.$route.query
		this.selectedSectors = []
		if(query.sectorId) {
			if(typeof query.sectorId == 'string') {
				this.selectedSectors = [parseInt(query.sectorId)]
			} else {
				this.selectedSectors = query.sectorId.map(Number)
			}
		}
		this.selectedRegions = []
		if(query.regionId) {
			if(typeof query.regionId == 'string') {
				this.selectedRegions = [parseInt(query.regionId)]
			} else {
				this.selectedRegions = query.regionId.map(Number)
			}
		}
		this.keyWordValue = query.name_like
		this.$root.$emit('highlightRegions')
	},
	methods: {
		...mapActions({
			getSectors: 'SectorStore/getList'
		}),
		search() {
			this.$router.push({
				name: 'opportunity-list',
				query: {
					...this.$route.query,
					sectorId: this.selectedSectors,
					regionId: this.selectedRegions,
					name_like: this.keyWordValue
				}
			})
		},
		checkSearch() {
			if(
				this.selectedSectors.length > 0 ||
				this.selectedRegions.length > 0 ||
				(this.keyWordValue != '' && this.keyWordValue != undefined)
			) {
				this.$refs.opportunitySearchButton.classList.remove('isDisabled')
			} else {
				this.$refs.opportunitySearchButton.classList.add('isDisabled')
			}
		}
	},
	watch: {
		selectedSectors() {
			this.checkSearch()
		},
		selectedRegions() {
			this.checkSearch()
		},
		keyWordValue() {
			this.checkSearch()
		}
	}
}
</script>

<style lang="scss">
.map-sidebar {
	.button {
		width: 156px;
	}
	.tabs-caption {
		border-bottom: 4px solid #4ba98b;
		margin-bottom: 0px;

		h3 {
			margin: 0;
			color: #fff;
			text-transform: uppercase;
			font-size: 10px;
			background: linear-gradient(to bottom, #181e24 50%, #1e262d 50%);
			border: 2px solid #1e262d;
			padding: 10px;
			border-bottom: 0 !important;
			border-top-left-radius: 20px;
			border-top-right-radius: 20px;
			font-weight: 500;
			cursor: pointer;
			user-select: none;
			width: 125px;
			box-sizing: border-box;

			&:hover {
				background: linear-gradient(to bottom, #54b1d7 50%, #3b9fce 50%);
				border: 2px solid #3b9fce;
			}
		}
		h3.active {
			background: linear-gradient(to bottom, #5eb9a2 50%, #4ba98b 50%);
			border: 2px solid #4ba98b;

			&:hover {
				background: #4ba98b;
			}
		}
	}
	.dropdown {
		.select {
			background-color: #141921;
		}

		ul {
			height: 500px;
		}
	}
}
</style>
